import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/_project/supplier-quote-request/$projectId/$subProjectId")({
  component: Outlet,
});
